import * as React from 'react';

import classnames from 'classnames';

import styles from './empty-add-card.module.css';

type Props = {
    onClick: () => void;
    text: string;
    background: 'white' | 'off-white';
    size: 'small' | 'large';
    isDisabled?: boolean;
    withoutIcon?: boolean;
    color?: string;
    isLoading?: boolean;
    height?: number;
};

export function EmptyAddCard(props: Props) {
    const styleNames = classnames({
        [styles['empty-add-card']]: true,
        [styles['off-white']]: props.background === 'off-white',
        [styles['variant-small']]: props.size === 'small',
    });

    const additionalStyles = {
        color: props.color,
        borderColor: props.color,
        height: props.height ? `${props.height}px` : undefined,
    } as const;

    return props.isLoading ? (
        <div
            className={
                props.background === 'white'
                    ? styles['loading-placeholder--white']
                    : styles['loading-placeholder']
            }
        />
    ) : (
        <button
            style={additionalStyles}
            onClick={props.onClick}
            disabled={props.isDisabled}
            className={styleNames}
        >
            {props.withoutIcon ? null : <div className={styles['add-card-icon']}>+</div>}
            <div className={styles['add-card-label']}>{props.text}</div>
        </button>
    );
}
